// Single source of truth for the "mute all mentions …" confirmation copy, so
// the exact same dialog shows whether the user mutes inline (clicking a link or
// hashtag in a mention) or through the spam/hide menu on a thread.
export function domainMuteConfirm(domain) {
  return {
    title: `Mute all mentions linking to ${domain}?`,
    body: `This hides every mention that links to ${domain} from your feed, going forward. You can undo this anytime from your mute settings.`,
    accept: "Mute domain",
    linkUrl: "/team_settings/muted_domains",
    linkLabel: "Muted domains"
  }
}

export function hashtagMuteConfirm(name) {
  return {
    title: `Mute all mentions with #${name}?`,
    body: `This hides every mention containing #${name} from your feed, going forward. You can undo this anytime from your mute settings.`,
    accept: "Mute hashtag",
    linkUrl: "/team_settings/muted_hashtags",
    linkLabel: "Muted hashtags"
  }
}

export function authorMuteConfirm(handle) {
  return {
    title: `Mute all mentions by ${handle}?`,
    body: `This hides every mention by ${handle} from your feed, going forward. You can undo this anytime from your mute settings.`,
    accept: "Mute author",
    linkUrl: "/team_settings/muted_authors",
    linkLabel: "Muted authors"
  }
}

export const MUTE_CONFIRMS = {
  domain: domainMuteConfirm,
  hashtag: hashtagMuteConfirm,
  author: authorMuteConfirm
}
